import { GetAppointmentsQueuesParams } from '@/modules/Telemedicine/queries/AppointmentQueue/AppointmentQueue.types'

class GetAppointmentsQueueListMapper {
  toPersistence(domainData: GetAppointmentsQueuesParams) {
    return {
      itemsPerPage: domainData?.itemsPerPage,
      page: domainData?.page,
      termo: domainData?.term,
      flagEncaixe: domainData?.flagEncaixe,
      publicoAtendimento: domainData?.patientType,
      ocultarAguardandoAtivacao: domainData?.hideAwaitingActivation,
    }
  }
}

export default new GetAppointmentsQueueListMapper()
